import Swiper, { Navigation } from 'swiper';
import 'swiper/css';
import STATE from '../enums/state.js';

const selectors = {
  carouselWrapper: '[data-positivity-luxury-carousel]',
  modal: '[data-positivity-luxury-modal]',
  openButton: '[data-positivity-luxury-open]',
  closeButton: '[data-positivity-luxury-close]',
  nextEl: '.swiper-button-next',
  prevEl: '.swiper-button-prev',
};

class PositivityLuxuryCarousel extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.carouselWrappers = this.querySelectorAll(selectors.carouselWrapper);
      this.modal = document.querySelector(selectors.modal);
      this.openButton = document.querySelector(selectors.openButton);
      this.closeButton = document.querySelector(selectors.closeButton);

      this.render();
    });
  }

  render() {
    // Init the carousel on load.
    this.initCarousels();

    // Subsequently, on resize, we need to check if we need a Swiper object checking the break point.
    // If not, it will get destroyed.
    this.registerEventListeners();
  }

  initCarousels() {
    this.carousel = new Swiper(selectors.carouselWrapper, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: selectors.nextEl,
        prevEl: selectors.prevEl,
      },
      watchOverflow: true,
      freeMode: true,
      breakpoints: {
        768: {
          spaceBetween: 30,
          slidesPerView: 2.5,
        },
      },
    });
  }

  registerEventListeners() {
    window.addEventListener('resize', () => {
      this.carousel.update();
    });

    this.openButton.addEventListener('click', () => {
      this.modal.dataset.state = STATE.POSITIVITY.OPEN;
    });

    this.closeButton.addEventListener('click', () => {
      this.modal.dataset.state = STATE.POSITIVITY.CLOSED;
    });
  }
}

customElements.define('positivity-luxury-carousel', PositivityLuxuryCarousel);
